export default (theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
  },

  formField: {
    marginRight: 8,
    width: '30%',
  },

  actions: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'row',
  },

  moreButton: {
    marginLeft: 16,
    marginRight: 0,
    width: 'auto',
    justifySelf: 'flex-end',
  },

  contentBit: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    '& span:first-child': {
      fontWeight: 500,
      fontSize: 15,
      color: '#27282A',
      textAlign: 'left',
      lineHeight: '24px',
    },

    '& span:nth-child(2)': {
      fontSize: 14,
      color: '#7B8B99',
      textAlign: 'left',
      lineHeight: '18px',
      display: 'flex',
      alignItems: 'center',
    },
  },

  folderIcon: {
    opacity: 0.5,
    marginRight: 5,
    width: 16,
    height: 16,
    position: 'relative',
    top: -1,
  },

  previewNotice: {
    fontSize: 14,
    textAlign: 'left',
    margin: '-8px 0 8px 0',
    lineHeight: '24px',
    color: '#7B8B99',

    '& p': {
      '&:first-child': {
        fontWeight: 500,
      },
    },

    '& a': {
      fontWeight: 500,
      color: theme.palette.text.link,
      '&:hover': {
        color: theme.palette.text.linkHover,
        '& svg *': {
          fill: theme.palette.text.linkHover,
        },
      },

      '& svg': {
        height: 16,
        width: 16,
        position: 'relative',
        top: 3,
      },
    },
  },

  previewNoticeTitle: {
    color: '#596168',
    fontWeight: 500,
  },

  footer: {
    fontSize: 14,
    color: '#7B8B99',
    '& svg': {
      marginRight: 8,
    },
  },
});
